import { RiCheckboxBlankCircleLine } from "react-icons/ri";
import {FaHistory, FaBell, FaLifeRing, FaCreditCard, FaDollarSign} from "react-icons/fa";
import { MdDashboard } from 'react-icons/md';

let CustomerNav = {
    dashboar: [
        { to: '/', name: 'customerHome', exact: "false", Icon: MdDashboard }
    ],
    // user: [
    //     { to: '/admin/khach-hang', name: 'userList', title: 'Khách hàng', exact: "false", Icon: RiCheckboxBlankCircleLine },
    //     { to: '/admin/khach-hang/tao-khach-hang', name: 'userCreate', title: 'Tạo khách hàng', exact: "false", Icon: RiCheckboxBlankCircleLine },
    //     { to: '/admin/dai-ly', name: 'groupUser', title: 'Đại lý', exact: "false", Icon: RiCheckboxBlankCircleLine },
    // ],
    // product: [
    //     { to: '/admin/san-pham', name: 'productList', title: 'Danh sách sản phẩm', exact: "false", Icon: RiCheckboxBlankCircleLine },
    // ],
    // order: [
    //     { to: '/admin/don-dat-hang', name: 'orderList', title: 'Danh sách đơn hàng', exact: "false", Icon: RiCheckboxBlankCircleLine },
    //     { to: '/admin/don-dat-hang/tao-don-hang', name: 'orderCreate', title: 'Tạo đơn hàng', exact: "false", Icon: RiCheckboxBlankCircleLine },
    // ],
    // log: [
    // 	{ to: '/admin/activity-log', name: 'listLog', title: 'List', exact: 'false', Icon: RiCheckboxBlankCircleLine }
    // ],
    // config_system: [
    //     { to: '/admin/config-system', name: 'configSystem', title: 'Config System', exact: 'false', Icon: RiCheckboxBlankCircleLine }
    // ],
    vps: [
        { to: '/dich-vu-vps/dang-su-dung.html', name: 'vpsUse', title: 'Đang sử dụng', exact: 'false', Icon: RiCheckboxBlankCircleLine },
        { to: '/dich-vu-vps/con-han.html', name: 'vpsUse', title: 'Còn hạn', exact: 'false', Icon: RiCheckboxBlankCircleLine },
        { to: '/dich-vu-vps/da-het-han.html', name: 'vpsUse', title: 'Đã hết hạn', exact: 'false', Icon: RiCheckboxBlankCircleLine },
        { to: '/dich-vu-vps/huy-xoa-chuyen.html', name: 'vpsUse', title: 'Hủy/Xóa/Chuyển', exact: 'false', Icon: RiCheckboxBlankCircleLine },
        { to: '/dich-vu-vps/tat-ca-dich-vu-vps.html', name: 'vpsUse', title: 'Tất Cả', exact: 'false', Icon: RiCheckboxBlankCircleLine },
    ],
    order: [
        { to: '/don-dat-hang/chua-thanh-toan.html', name: 'unpaidOrder', title: 'Chưa thanh toán', exact: "false", Icon: RiCheckboxBlankCircleLine },
        { to: '/don-dat-hang/da-thanh-toan.html', name: 'paidOrder', title: 'Đã thanh toán', exact: "false", Icon: RiCheckboxBlankCircleLine },
        { to: '/don-dat-hang/tat-ca-don-hang.html', name: 'allOrder', title: 'Tất cả', exact: "false", Icon: RiCheckboxBlankCircleLine },
    ],
    recharge: [
        { to: '/quan-ly-giao-dich/nap-tien-tai-khoan.html', name: 'rechargeCredit', title: 'Nạp tiền tài khoản', exact: "false", Icon: FaDollarSign },
    ],
    payment: [
        { to: '/quan-ly-giao-dich/lich-su-giao-dich.html', name: 'historyPayment', title: 'Lịch sử giao dịch', exact: "false", Icon: FaCreditCard },
    ],
    notification: [
        { to: '/thong-bao/danh-sach-thong-bao.html', name: 'notification', title: 'Thông báo', exact: 'false', Icon: FaBell }
    ],
    ticket: [
        { to: '/ho-tro/danh-sach-ho-tro.html', name: 'ticket', title: 'Hổ trợ', exact: 'false', Icon: FaLifeRing }
    ],
    log: [
        { to: '/activity-log', name: 'listLog', title: 'List Log', exact: 'false', Icon: FaHistory }
    ]
};

export default CustomerNav;